var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("FormSubmitPopup", {
    ref: "formPopup",
    attrs: {
      title: _vm.title,
      rightMethod: _vm.onSubmitted,
      rightButtonDisabled: _vm.isAutoGetRate && !_vm.autoGetRateComplete,
      rightButtonText: _vm.$t("submit"),
      hasAlert: "",
      classes: ["labelPopup"],
      large: ""
    },
    on: {
      popupClose: function($event) {
        return _vm.$emit("input", false)
      }
    },
    scopedSlots: _vm._u([
      {
        key: "input",
        fn: function() {
          return [
            _c(
              "v-container",
              { attrs: { "py-0": "", fluid: "" } },
              [
                _c(
                  "v-layout",
                  { attrs: { row: "" } },
                  [
                    _c(
                      "v-flex",
                      { attrs: { xs12: "" } },
                      [
                        _c("v-autocomplete", {
                          attrs: {
                            "hide-details": "",
                            items: _vm.labelTemplates,
                            "return-object": "",
                            label: _vm.$t("template"),
                            "item-text": "name"
                          },
                          on: { change: _vm.applyLabelTemplate }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-layout",
                  { attrs: { row: "" } },
                  [
                    _c(
                      "v-flex",
                      { attrs: { md6: "" } },
                      [
                        _c(
                          "v-card",
                          { attrs: { width: "100%" } },
                          [
                            _c(
                              "v-card-text",
                              { staticStyle: { "padding-top": "5px" } },
                              [
                                _c(
                                  "v-layout",
                                  { attrs: { "align-baseline": "" } },
                                  [
                                    _c(
                                      "v-flex",
                                      {
                                        staticClass: "title",
                                        attrs: { md3: "" }
                                      },
                                      [_vm._v(_vm._s(_vm.$t("sender")) + ": ")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-flex",
                                      { attrs: { md4: "" } },
                                      [
                                        _c("vite-autocomplete", {
                                          attrs: {
                                            "hide-details": "",
                                            items: _vm.fromAddress,
                                            "return-object": "",
                                            label: _vm.$t("addressName"),
                                            "item-text": "siteName",
                                            "item-value": "key"
                                          },
                                          on: {
                                            change: function(address) {
                                              if (address.siteId) {
                                                _vm.from.siteId = address.siteId
                                              } else {
                                                delete _vm.from.siteId
                                              }
                                            }
                                          },
                                          model: {
                                            value: _vm.fromTemplate,
                                            callback: function($$v) {
                                              _vm.fromTemplate = $$v
                                            },
                                            expression: "fromTemplate"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-flex",
                                      { attrs: { md6: "" } },
                                      [
                                        !_vm.isSupportDangerousGoods &&
                                        !_vm.isFreight
                                          ? _c("v-checkbox", {
                                              staticClass: "checkbox",
                                              attrs: {
                                                "hide-details": "",
                                                label: _vm.$t("save")
                                              },
                                              model: {
                                                value: _vm.isSaveFrom,
                                                callback: function($$v) {
                                                  _vm.isSaveFrom = $$v
                                                },
                                                expression: "isSaveFrom"
                                              }
                                            })
                                          : _vm._e()
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-flex",
                                      { attrs: { md6: "" } },
                                      [
                                        _c(
                                          "v-btn",
                                          {
                                            attrs: {
                                              flat: "",
                                              color: "primary"
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.toggleParseAddress(
                                                  "isShowFromParseAddress",
                                                  "parseFormAddress",
                                                  _vm.from
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$t("parseAddress"))
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _vm.isSaveFrom
                                      ? _c(
                                          "v-flex",
                                          { attrs: { md6: "" } },
                                          [
                                            _vm.isSaveFrom &&
                                            !_vm.isSupportDangerousGoods
                                              ? _c("v-text-field", {
                                                  staticClass: "required_field",
                                                  attrs: {
                                                    "hide-details": "",
                                                    label: _vm.$t(
                                                      "addressName"
                                                    ),
                                                    rules: [
                                                      _vm.fieldIsRequired(
                                                        "Site name"
                                                      ),
                                                      function(v) {
                                                        return v ===
                                                          _vm.to.siteName &&
                                                          _vm.isSaveTo
                                                          ? _vm.$t(
                                                              "siteNameIsSameAsToSite"
                                                            )
                                                          : true
                                                      }
                                                    ]
                                                  },
                                                  model: {
                                                    value: _vm.from.siteName,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.from,
                                                        "siteName",
                                                        typeof $$v === "string"
                                                          ? $$v.trim()
                                                          : $$v
                                                      )
                                                    },
                                                    expression: "from.siteName"
                                                  }
                                                })
                                              : _vm._e()
                                          ],
                                          1
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _vm.isShowFromParseAddress
                                  ? _c(
                                      "v-layout",
                                      [
                                        _c("v-textarea", {
                                          attrs: {
                                            label: _vm.$t("fullAddress"),
                                            outline: "",
                                            rows: "3",
                                            "hide-details": ""
                                          },
                                          on: {
                                            input: function(e) {
                                              return _vm.changeAddress(
                                                e,
                                                "from"
                                              )
                                            }
                                          },
                                          model: {
                                            value: _vm.parseFormAddress,
                                            callback: function($$v) {
                                              _vm.parseFormAddress =
                                                typeof $$v === "string"
                                                  ? $$v.trim()
                                                  : $$v
                                            },
                                            expression: "parseFormAddress"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "v-layout",
                                  { attrs: { "justify-space-between": "" } },
                                  [
                                    _c(
                                      "v-flex",
                                      { attrs: { xs7: "" } },
                                      [
                                        _c(
                                          "v-layout",
                                          {
                                            attrs: {
                                              "justify-space-between": ""
                                            }
                                          },
                                          [
                                            _c(
                                              "v-flex",
                                              { attrs: { xs5: "" } },
                                              [
                                                _c("v-text-field", {
                                                  staticClass: "required_field",
                                                  attrs: {
                                                    "hide-details": "",
                                                    label: _vm.$t("fullName"),
                                                    rules: [
                                                      _vm.fieldIsRequired(
                                                        "Full name"
                                                      ),
                                                      _vm.fieldCharLimit(
                                                        "Full name",
                                                        35
                                                      )
                                                    ]
                                                  },
                                                  model: {
                                                    value: _vm.from.fullName,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.from,
                                                        "fullName",
                                                        typeof $$v === "string"
                                                          ? $$v.trim()
                                                          : $$v
                                                      )
                                                    },
                                                    expression: "from.fullName"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-flex",
                                              { attrs: { xs5: "" } },
                                              [
                                                _c(
                                                  "v-layout",
                                                  {
                                                    attrs: {
                                                      "justify-space-between":
                                                        ""
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "v-flex",
                                                      _vm._b(
                                                        {},
                                                        "v-flex",
                                                        {
                                                          xs7:
                                                            _vm
                                                              .currentShippingService
                                                              .isSupportFromExt,
                                                          xs12: !_vm
                                                            .currentShippingService
                                                            .isSupportFromExt
                                                        },
                                                        false
                                                      ),
                                                      [
                                                        _c("v-text-field", {
                                                          staticClass:
                                                            "required_field",
                                                          attrs: {
                                                            "hide-details": "",
                                                            label: _vm.$t(
                                                              "phone"
                                                            )
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.from.phone,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.from,
                                                                "phone",
                                                                typeof $$v ===
                                                                  "string"
                                                                  ? $$v.trim()
                                                                  : $$v
                                                              )
                                                            },
                                                            expression:
                                                              "from.phone"
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _vm.currentShippingService
                                                      .isSupportFromExt
                                                      ? _c(
                                                          "v-flex",
                                                          {
                                                            attrs: { xs4: "" }
                                                          },
                                                          [
                                                            _c("v-text-field", {
                                                              attrs: {
                                                                "hide-details":
                                                                  "",
                                                                label: _vm.$t(
                                                                  "extension"
                                                                ),
                                                                rules: [
                                                                  _vm.fieldCharLimit(
                                                                    "extension",
                                                                    6
                                                                  )
                                                                ]
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm.from
                                                                    .extension,
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    _vm.from,
                                                                    "extension",
                                                                    typeof $$v ===
                                                                      "string"
                                                                      ? $$v.trim()
                                                                      : $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "from.extension"
                                                              }
                                                            })
                                                          ],
                                                          1
                                                        )
                                                      : _vm._e()
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-flex",
                                      { attrs: { xs4: "" } },
                                      [
                                        _c("v-text-field", {
                                          attrs: {
                                            "hide-details": "",
                                            label: _vm.$t("companyName")
                                          },
                                          model: {
                                            value: _vm.from.company,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.from,
                                                "company",
                                                typeof $$v === "string"
                                                  ? $$v.trim()
                                                  : $$v
                                              )
                                            },
                                            expression: "from.company"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-layout",
                                  { attrs: { "justify-space-between": "" } },
                                  [
                                    _c(
                                      "v-flex",
                                      { attrs: { xs7: "" } },
                                      [
                                        _c("v-text-field", {
                                          staticClass: "required_field",
                                          attrs: {
                                            "hide-details": "",
                                            label: _vm.$t("address") + " 1",
                                            readonly:
                                              _vm.isSupportDangerousGoods ||
                                              _vm.isFreight,
                                            rules: [
                                              _vm.fieldIsRequired("Address"),
                                              _vm.fieldCharLimit("Address1", 50)
                                            ]
                                          },
                                          model: {
                                            value: _vm.from.address1,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.from,
                                                "address1",
                                                typeof $$v === "string"
                                                  ? $$v.trim()
                                                  : $$v
                                              )
                                            },
                                            expression: "from.address1"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-flex",
                                      { attrs: { xs4: "" } },
                                      [
                                        _c("v-text-field", {
                                          attrs: {
                                            "hide-details": "",
                                            label: _vm.$t("address") + " 2",
                                            rules: [
                                              _vm.fieldCharLimit("Address2", 50)
                                            ]
                                          },
                                          model: {
                                            value: _vm.from.address2,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.from,
                                                "address2",
                                                typeof $$v === "string"
                                                  ? $$v.trim()
                                                  : $$v
                                              )
                                            },
                                            expression: "from.address2"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-layout",
                                  { attrs: { "justify-space-between": "" } },
                                  [
                                    _c(
                                      "v-flex",
                                      { attrs: { xs7: "" } },
                                      [
                                        _c(
                                          "v-layout",
                                          {
                                            attrs: {
                                              "justify-space-between": ""
                                            }
                                          },
                                          [
                                            _c(
                                              "v-flex",
                                              { attrs: { xs5: "" } },
                                              [
                                                _c("v-text-field", {
                                                  staticClass: "required_field",
                                                  attrs: {
                                                    "hide-details": "",
                                                    label: _vm.$t("city"),
                                                    rules: [
                                                      _vm.fieldIsRequired(
                                                        "City"
                                                      )
                                                    ],
                                                    readonly:
                                                      _vm.isSupportDangerousGoods ||
                                                      _vm.isFreight
                                                  },
                                                  model: {
                                                    value: _vm.from.city,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.from,
                                                        "city",
                                                        typeof $$v === "string"
                                                          ? $$v.trim()
                                                          : $$v
                                                      )
                                                    },
                                                    expression: "from.city"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-flex",
                                              { attrs: { xs5: "" } },
                                              [
                                                _c("vite-autocomplete", {
                                                  staticClass: "required_field",
                                                  attrs: {
                                                    "hide-details": "",
                                                    items: _vm.states,
                                                    label: _vm.$t("state"),
                                                    rules: [
                                                      _vm.fieldIsRequired(
                                                        "State"
                                                      )
                                                    ],
                                                    readonly:
                                                      _vm.isSupportDangerousGoods ||
                                                      _vm.isFreight
                                                  },
                                                  scopedSlots: _vm._u([
                                                    {
                                                      key: "item",
                                                      fn: function(data) {
                                                        return [
                                                          [
                                                            _c(
                                                              "v-list-tile-content",
                                                              [
                                                                _c(
                                                                  "v-list-tile-title",
                                                                  {
                                                                    attrs: {
                                                                      id:
                                                                        data.item
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n                                " +
                                                                        _vm._s(
                                                                          data.item
                                                                        ) +
                                                                        "\n                              "
                                                                    )
                                                                  ]
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          ]
                                                        ]
                                                      }
                                                    }
                                                  ]),
                                                  model: {
                                                    value: _vm.from.state,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.from,
                                                        "state",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "from.state"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-flex",
                                      { attrs: { xs4: "" } },
                                      [
                                        _c("v-text-field", {
                                          staticClass: "required_field",
                                          attrs: {
                                            "hide-details": "",
                                            label: _vm.$t("zipCode"),
                                            readonly:
                                              _vm.isSupportDangerousGoods ||
                                              _vm.isFreight,
                                            rules: [
                                              _vm.fieldIsRequired("Zip code")
                                            ]
                                          },
                                          model: {
                                            value: _vm.from.zipCode,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.from,
                                                "zipCode",
                                                typeof $$v === "string"
                                                  ? $$v.trim()
                                                  : $$v
                                              )
                                            },
                                            expression: "from.zipCode"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-flex",
                      { attrs: { md6: "" } },
                      [
                        _c(
                          "v-card",
                          { attrs: { width: "100%" } },
                          [
                            _c(
                              "v-card-text",
                              { staticStyle: { "padding-top": "5px" } },
                              [
                                _c(
                                  "v-layout",
                                  { attrs: { "align-baseline": "" } },
                                  [
                                    _c(
                                      "v-flex",
                                      {
                                        staticClass: "title",
                                        attrs: { md3: "" }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("recipient")) + ": "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-flex",
                                      { attrs: { md4: "" } },
                                      [
                                        _c("vite-autocomplete", {
                                          attrs: {
                                            "hide-details": "",
                                            items: _vm.addresses,
                                            "return-object": "",
                                            label: _vm.$t("addressName"),
                                            "item-text": "siteName",
                                            "item-value": "siteName"
                                          },
                                          model: {
                                            value: _vm.toTemplate,
                                            callback: function($$v) {
                                              _vm.toTemplate = $$v
                                            },
                                            expression: "toTemplate"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-flex",
                                      { attrs: { md2: "" } },
                                      [
                                        _c("v-checkbox", {
                                          staticClass: "checkbox",
                                          attrs: {
                                            "hide-details": "",
                                            label: _vm.$t("save")
                                          },
                                          model: {
                                            value: _vm.isSaveTo,
                                            callback: function($$v) {
                                              _vm.isSaveTo = $$v
                                            },
                                            expression: "isSaveTo"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-flex",
                                      { attrs: { md3: "" } },
                                      [
                                        _c(
                                          "v-btn",
                                          {
                                            attrs: {
                                              flat: "",
                                              color: "primary"
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.toggleParseAddress(
                                                  "isShowToParseAddress",
                                                  "parseToAddress",
                                                  _vm.to
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$t("parseAddress"))
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _vm.isSaveTo
                                      ? _c(
                                          "v-flex",
                                          { attrs: { md6: "" } },
                                          [
                                            _vm.isSaveTo
                                              ? _c("v-text-field", {
                                                  staticClass: "required_field",
                                                  attrs: {
                                                    "hide-details": "",
                                                    label: _vm.$t(
                                                      "addressName"
                                                    ),
                                                    rules: [
                                                      _vm.fieldIsRequired(
                                                        "Site name"
                                                      ),
                                                      function(v) {
                                                        return v ===
                                                          _vm.from.siteName &&
                                                          _vm.isSaveFrom
                                                          ? _vm.$t(
                                                              "siteNameIsSameAsToSite"
                                                            )
                                                          : true
                                                      }
                                                    ]
                                                  },
                                                  model: {
                                                    value: _vm.to.siteName,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.to,
                                                        "siteName",
                                                        typeof $$v === "string"
                                                          ? $$v.trim()
                                                          : $$v
                                                      )
                                                    },
                                                    expression: "to.siteName"
                                                  }
                                                })
                                              : _vm._e()
                                          ],
                                          1
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _vm.isShowToParseAddress
                                  ? _c(
                                      "v-layout",
                                      [
                                        _c("v-textarea", {
                                          attrs: {
                                            label: _vm.$t("fullAddress"),
                                            outline: "",
                                            rows: "3",
                                            "hide-details": ""
                                          },
                                          on: {
                                            input: function(e) {
                                              return _vm.changeAddress(e, "to")
                                            }
                                          },
                                          model: {
                                            value: _vm.parseToAddress,
                                            callback: function($$v) {
                                              _vm.parseToAddress =
                                                typeof $$v === "string"
                                                  ? $$v.trim()
                                                  : $$v
                                            },
                                            expression: "parseToAddress"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "v-layout",
                                  { attrs: { "justify-space-between": "" } },
                                  [
                                    _c(
                                      "v-flex",
                                      { attrs: { xs7: "" } },
                                      [
                                        _c(
                                          "v-layout",
                                          {
                                            attrs: {
                                              "justify-space-between": ""
                                            }
                                          },
                                          [
                                            _c(
                                              "v-flex",
                                              { attrs: { xs5: "" } },
                                              [
                                                _c("v-text-field", {
                                                  staticClass: "required_field",
                                                  attrs: {
                                                    "hide-details": "",
                                                    label: _vm.$t("fullName"),
                                                    rules: [
                                                      _vm.fieldIsRequired(
                                                        "Full name"
                                                      ),
                                                      _vm.fieldCharLimit(
                                                        "Full name",
                                                        35
                                                      )
                                                    ]
                                                  },
                                                  model: {
                                                    value: _vm.to.fullName,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.to,
                                                        "fullName",
                                                        typeof $$v === "string"
                                                          ? $$v.trim()
                                                          : $$v
                                                      )
                                                    },
                                                    expression: "to.fullName"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-flex",
                                              { attrs: { xs5: "" } },
                                              [
                                                _c(
                                                  "v-layout",
                                                  {
                                                    attrs: {
                                                      "justify-space-between":
                                                        ""
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "v-flex",
                                                      _vm._b(
                                                        {},
                                                        "v-flex",
                                                        {
                                                          xs7:
                                                            _vm
                                                              .currentShippingService
                                                              .isSupportToExt,
                                                          xs12: !_vm
                                                            .currentShippingService
                                                            .isSupportToExt
                                                        },
                                                        false
                                                      ),
                                                      [
                                                        _c("v-text-field", {
                                                          staticClass:
                                                            "required_field",
                                                          attrs: {
                                                            "hide-details": "",
                                                            label: _vm.$t(
                                                              "phone"
                                                            )
                                                          },
                                                          model: {
                                                            value: _vm.to.phone,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.to,
                                                                "phone",
                                                                typeof $$v ===
                                                                  "string"
                                                                  ? $$v.trim()
                                                                  : $$v
                                                              )
                                                            },
                                                            expression:
                                                              "to.phone"
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _vm.currentShippingService
                                                      .isSupportToExt
                                                      ? _c(
                                                          "v-flex",
                                                          {
                                                            attrs: { xs4: "" }
                                                          },
                                                          [
                                                            _c("v-text-field", {
                                                              attrs: {
                                                                "hide-details":
                                                                  "",
                                                                label: _vm.$t(
                                                                  "extension"
                                                                ),
                                                                rules: [
                                                                  _vm.fieldCharLimit(
                                                                    "extension",
                                                                    6
                                                                  )
                                                                ]
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm.to
                                                                    .extension,
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    _vm.to,
                                                                    "extension",
                                                                    typeof $$v ===
                                                                      "string"
                                                                      ? $$v.trim()
                                                                      : $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "to.extension"
                                                              }
                                                            })
                                                          ],
                                                          1
                                                        )
                                                      : _vm._e()
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-flex",
                                      { attrs: { xs4: "" } },
                                      [
                                        _c("v-text-field", {
                                          attrs: {
                                            "hide-details": "",
                                            label: _vm.$t("companyName")
                                          },
                                          model: {
                                            value: _vm.to.company,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.to,
                                                "company",
                                                typeof $$v === "string"
                                                  ? $$v.trim()
                                                  : $$v
                                              )
                                            },
                                            expression: "to.company"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-layout",
                                  { attrs: { "justify-space-between": "" } },
                                  [
                                    _c(
                                      "v-flex",
                                      { attrs: { xs7: "" } },
                                      [
                                        _c("v-text-field", {
                                          staticClass: "required_field",
                                          attrs: {
                                            "hide-details": "",
                                            label: _vm.$t("address") + " 1",
                                            rules: [
                                              _vm.fieldIsRequired("Address"),
                                              _vm.fieldCharLimit("address", 50)
                                            ]
                                          },
                                          model: {
                                            value: _vm.to.address1,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.to,
                                                "address1",
                                                typeof $$v === "string"
                                                  ? $$v.trim()
                                                  : $$v
                                              )
                                            },
                                            expression: "to.address1"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-flex",
                                      { attrs: { xs4: "" } },
                                      [
                                        _c("v-text-field", {
                                          attrs: {
                                            "hide-details": "",
                                            label: _vm.$t("address") + " 2",
                                            rules: [
                                              _vm.fieldCharLimit("Address2", 50)
                                            ]
                                          },
                                          model: {
                                            value: _vm.to.address2,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.to,
                                                "address2",
                                                typeof $$v === "string"
                                                  ? $$v.trim()
                                                  : $$v
                                              )
                                            },
                                            expression: "to.address2"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-layout",
                                  { attrs: { "justify-space-between": "" } },
                                  [
                                    _c(
                                      "v-flex",
                                      { attrs: { xs7: "" } },
                                      [
                                        _c(
                                          "v-layout",
                                          {
                                            attrs: {
                                              "justify-space-between": ""
                                            }
                                          },
                                          [
                                            _c(
                                              "v-flex",
                                              { attrs: { xs5: "" } },
                                              [
                                                _c("v-text-field", {
                                                  staticClass: "required_field",
                                                  attrs: {
                                                    "hide-details": "",
                                                    label: _vm.$t("city"),
                                                    rules: [
                                                      _vm.fieldIsRequired(
                                                        "City"
                                                      )
                                                    ]
                                                  },
                                                  model: {
                                                    value: _vm.to.city,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.to,
                                                        "city",
                                                        typeof $$v === "string"
                                                          ? $$v.trim()
                                                          : $$v
                                                      )
                                                    },
                                                    expression: "to.city"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-flex",
                                              { attrs: { xs5: "" } },
                                              [
                                                _c("vite-autocomplete", {
                                                  staticClass: "required_field",
                                                  attrs: {
                                                    "hide-details": "",
                                                    items: _vm.states,
                                                    label: _vm.$t("state"),
                                                    rules: [
                                                      _vm.fieldIsRequired(
                                                        "State"
                                                      )
                                                    ]
                                                  },
                                                  scopedSlots: _vm._u([
                                                    {
                                                      key: "item",
                                                      fn: function(data) {
                                                        return [
                                                          [
                                                            _c(
                                                              "v-list-tile-content",
                                                              [
                                                                _c(
                                                                  "v-list-tile-title",
                                                                  {
                                                                    attrs: {
                                                                      id:
                                                                        data.item
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n                                " +
                                                                        _vm._s(
                                                                          data.item
                                                                        ) +
                                                                        "\n                              "
                                                                    )
                                                                  ]
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          ]
                                                        ]
                                                      }
                                                    }
                                                  ]),
                                                  model: {
                                                    value: _vm.to.state,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.to,
                                                        "state",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "to.state"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-flex",
                                      { attrs: { xs4: "" } },
                                      [
                                        _c(
                                          "v-layout",
                                          {
                                            attrs: {
                                              "justify-space-around": "",
                                              "align-baseline": ""
                                            }
                                          },
                                          [
                                            _c(
                                              "v-flex",
                                              [
                                                _c("v-text-field", {
                                                  staticClass: "required_field",
                                                  attrs: {
                                                    "hide-details": "",
                                                    label: _vm.$t("zipCode"),
                                                    rules: [
                                                      _vm.fieldIsRequired(
                                                        "Zip code"
                                                      )
                                                    ]
                                                  },
                                                  model: {
                                                    value: _vm.to.zipCode,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.to,
                                                        "zipCode",
                                                        typeof $$v === "string"
                                                          ? $$v.trim()
                                                          : $$v
                                                      )
                                                    },
                                                    expression: "to.zipCode"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-flex",
                                              { attrs: { xs2: "" } },
                                              [
                                                _c(
                                                  "v-tooltip",
                                                  {
                                                    attrs: { top: "" },
                                                    scopedSlots: _vm._u([
                                                      {
                                                        key: "activator",
                                                        fn: function(ref) {
                                                          var on = ref.on
                                                          return [
                                                            _c(
                                                              "v-btn",
                                                              _vm._g(
                                                                {
                                                                  attrs: {
                                                                    disabled:
                                                                      _vm.googleMapDisabled,
                                                                    icon: "",
                                                                    flat: "",
                                                                    color:
                                                                      "primary",
                                                                    small: ""
                                                                  },
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      $event.stopPropagation()
                                                                      return _vm.goToGoogleMapLink.apply(
                                                                        null,
                                                                        arguments
                                                                      )
                                                                    }
                                                                  }
                                                                },
                                                                on
                                                              ),
                                                              [
                                                                _c("v-icon", [
                                                                  _vm._v(
                                                                    "location_on"
                                                                  )
                                                                ])
                                                              ],
                                                              1
                                                            )
                                                          ]
                                                        }
                                                      }
                                                    ])
                                                  },
                                                  [
                                                    _vm._v(" "),
                                                    _c("span", [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$t("googleMap")
                                                          )
                                                      )
                                                    ])
                                                  ]
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  [
                                    _c(
                                      "v-layout",
                                      {
                                        attrs: {
                                          "justify-end": "",
                                          "align-center": ""
                                        }
                                      },
                                      [
                                        _c(
                                          "v-btn",
                                          {
                                            attrs: {
                                              flat: "",
                                              color: "primary",
                                              small: "",
                                              disabled:
                                                _vm.disabledAddressValidation,
                                              loading:
                                                _vm.verificationAddressLoading
                                            },
                                            on: {
                                              click: _vm.verificationAddress
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("addressVerification")
                                              )
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-layout",
                                      {
                                        attrs: {
                                          "justify-end": "",
                                          "align-center": ""
                                        }
                                      },
                                      [
                                        _vm.toAddressValidationInfo
                                          ? _c(
                                              "v-flex",
                                              {
                                                staticStyle: {
                                                  "text-align": "right"
                                                }
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      color: "#ffa000",
                                                      "text-align": "right"
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm
                                                          .toAddressValidationInfo
                                                          .addressType
                                                      )
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t("recommendAddress")
                                                    ) +
                                                      ": " +
                                                      _vm._s(
                                                        _vm.recommendAddressFormatFunc(
                                                          _vm
                                                            .toAddressValidationInfo
                                                            .recommendAddress
                                                        )
                                                      )
                                                  )
                                                ]),
                                                _vm._v(" "),
                                                _c(
                                                  "v-btn",
                                                  {
                                                    attrs: {
                                                      small: "",
                                                      flat: "",
                                                      color: "primary"
                                                    },
                                                    on: {
                                                      click: function() {
                                                        return (_vm.to = Object.assign(
                                                          {},
                                                          _vm.to,
                                                          _vm
                                                            .toAddressValidationInfo
                                                            .recommendAddress
                                                        ))
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(_vm.$t("apply"))
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            )
                                          : _vm._e()
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.hasHazmatFeatures && _vm.isLabelServiceSupportDangerousGoods
                  ? _c(
                      "v-layout",
                      { attrs: { row: "" } },
                      [
                        _c(
                          "v-flex",
                          [
                            _c(
                              "v-card",
                              { attrs: { width: "100%" } },
                              [
                                _c(
                                  "v-card-text",
                                  [
                                    _c("HazardousCommodities", {
                                      ref: "HazardousCommodities",
                                      attrs: {
                                        dangerousGoods: _vm.dangerousGoods,
                                        offerorName: _vm.offerorName,
                                        emergencyContactNumber:
                                          _vm.emergencyContactNumber,
                                        dryIceWeight: _vm.dryIceDetail.weight,
                                        dryIceUnit: _vm.dryIceDetail.unit,
                                        filterItems: ["", "LITHIUM_BATTERY"],
                                        isPrintSafetyDocument:
                                          _vm.isPrintSafetyDocument,
                                        signatureCode: _vm.signatureCode
                                      },
                                      on: {
                                        "update:dangerousGoods": function(
                                          $event
                                        ) {
                                          _vm.dangerousGoods = $event
                                        },
                                        "update:dangerous-goods": function(
                                          $event
                                        ) {
                                          _vm.dangerousGoods = $event
                                        },
                                        "update:offerorName": function($event) {
                                          _vm.offerorName = $event
                                        },
                                        "update:offeror-name": function(
                                          $event
                                        ) {
                                          _vm.offerorName = $event
                                        },
                                        "update:emergencyContactNumber": function(
                                          $event
                                        ) {
                                          _vm.emergencyContactNumber = $event
                                        },
                                        "update:emergency-contact-number": function(
                                          $event
                                        ) {
                                          _vm.emergencyContactNumber = $event
                                        },
                                        "update:dryIceWeight": function(
                                          $event
                                        ) {
                                          return _vm.$set(
                                            _vm.dryIceDetail,
                                            "weight",
                                            $event
                                          )
                                        },
                                        "update:dry-ice-weight": function(
                                          $event
                                        ) {
                                          return _vm.$set(
                                            _vm.dryIceDetail,
                                            "weight",
                                            $event
                                          )
                                        },
                                        "update:dryIceUnit": function($event) {
                                          return _vm.$set(
                                            _vm.dryIceDetail,
                                            "unit",
                                            $event
                                          )
                                        },
                                        "update:dry-ice-unit": function(
                                          $event
                                        ) {
                                          return _vm.$set(
                                            _vm.dryIceDetail,
                                            "unit",
                                            $event
                                          )
                                        },
                                        "update:isPrintSafetyDocument": function(
                                          $event
                                        ) {
                                          _vm.isPrintSafetyDocument = $event
                                        },
                                        "update:is-print-safety-document": function(
                                          $event
                                        ) {
                                          _vm.isPrintSafetyDocument = $event
                                        },
                                        "update:signatureCode": function(
                                          $event
                                        ) {
                                          _vm.signatureCode = $event
                                        },
                                        "update:signature-code": function(
                                          $event
                                        ) {
                                          _vm.signatureCode = $event
                                        }
                                      },
                                      model: {
                                        value: _vm.hazMatsInfo,
                                        callback: function($$v) {
                                          _vm.hazMatsInfo = $$v
                                        },
                                        expression: "hazMatsInfo"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "v-layout",
                  { attrs: { row: "" } },
                  [
                    _c(
                      "v-flex",
                      [
                        _c(
                          "v-card",
                          { attrs: { width: "100%" } },
                          [
                            _c(
                              "v-card-text",
                              [
                                !_vm.isFreight
                                  ? _c("LabelPackageWidget", {
                                      ref: "LabelPackageWidget",
                                      attrs: {
                                        to: _vm.to,
                                        packages: _vm.packages,
                                        noteMemoSignature:
                                          _vm.noteMemoSignature,
                                        shippingService: _vm.shippingService,
                                        carrier: _vm.carrier,
                                        carriers: _vm.carriers,
                                        autoGetRateComplete:
                                          _vm.autoGetRateComplete,
                                        initLabelStockType:
                                          _vm.labelInfo.labelStockType,
                                        initIsSaturdayDelivery:
                                          _vm.labelInfo.isSaturdayDelivery,
                                        fromState: _vm.from.state,
                                        order: _vm.order,
                                        dangerousGoods: _vm.dangerousGoods
                                      },
                                      on: {
                                        "update:packages": function($event) {
                                          _vm.packages = $event
                                        },
                                        "update:shippingService": function(
                                          $event
                                        ) {
                                          _vm.shippingService = $event
                                        },
                                        "update:shipping-service": function(
                                          $event
                                        ) {
                                          _vm.shippingService = $event
                                        },
                                        "update:carrier": function($event) {
                                          _vm.carrier = $event
                                        },
                                        "update:carriers": function($event) {
                                          _vm.carriers = $event
                                        },
                                        clearDangerousGoods:
                                          _vm.clearDangerousGoods,
                                        selectTemplate: _vm.selectTemplate
                                      }
                                    })
                                  : _c("LabelFreightPkgWidget", {
                                      ref: "LabelPackageWidget",
                                      attrs: {
                                        packages: _vm.packages,
                                        noteMemoSignature:
                                          _vm.noteMemoSignature,
                                        shippingService: _vm.shippingService,
                                        carrier: _vm.carrier,
                                        initLabelStockType:
                                          _vm.labelInfo.labelStockType,
                                        initIsSaturdayDelivery:
                                          _vm.labelInfo.isSaturdayDelivery,
                                        fromState: _vm.from.state,
                                        isFreight: _vm.isFreight
                                      },
                                      on: {
                                        "update:packages": function($event) {
                                          _vm.packages = $event
                                        },
                                        "update:shippingService": function(
                                          $event
                                        ) {
                                          _vm.shippingService = $event
                                        },
                                        "update:shipping-service": function(
                                          $event
                                        ) {
                                          _vm.shippingService = $event
                                        },
                                        "update:carrier": function($event) {
                                          _vm.carrier = $event
                                        },
                                        selectTemplate: _vm.selectTemplate
                                      }
                                    })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-layout",
                  { attrs: { column: "" } },
                  [
                    _c(
                      "v-flex",
                      [
                        _c(
                          "v-layout",
                          {
                            attrs: { "justify-end": "", "align-baseline": "" }
                          },
                          [
                            false
                              ? _c(
                                  "v-flex",
                                  { attrs: { xs6: "", md2: "" } },
                                  [
                                    _c("v-text-field", {
                                      staticClass: "required_field",
                                      attrs: {
                                        label: _vm.$t("duplicateShipments"),
                                        rules: [
                                          _vm.fieldIsRequired("quantity"),
                                          _vm.fieldIsInteger("quantity"),
                                          _vm.fieldIsOverZero("quantity"),
                                          _vm.limitMultipleShipping
                                        ]
                                      },
                                      model: {
                                        value: _vm.quantity,
                                        callback: function($$v) {
                                          _vm.quantity = _vm._n($$v)
                                        },
                                        expression: "quantity"
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.serviceSetting.cancelHint
                              ? _c(
                                  "v-flex",
                                  {
                                    staticStyle: {
                                      border: "1px solid black",
                                      "border-radius": "2px"
                                    },
                                    attrs: {
                                      xs4: "",
                                      md3: "",
                                      "text-xs-center": ""
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.$t(_vm.serviceSetting.cancelHint)
                                        ) +
                                        "\n            "
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "v-flex",
                              { attrs: { xs8: "" } },
                              [
                                _c(
                                  "v-layout",
                                  {
                                    attrs: {
                                      "align-baseline": "",
                                      "justify-end": ""
                                    }
                                  },
                                  [
                                    _vm.autoGetRateComplete && _vm.isAutoGetRate
                                      ? _c(
                                          "v-flex",
                                          { attrs: { md3: "", "mr-5": "" } },
                                          [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "selectedShippingService"
                                                  ) + ": "
                                                )
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                staticClass: "font-weight-black"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.displayRate
                                                      .serviceDescription
                                                  )
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "v-flex",
                                      { attrs: { md2: "" } },
                                      [
                                        _c(
                                          "v-btn",
                                          {
                                            attrs: {
                                              color: "primary",
                                              disabled: _vm.isLoadingRates
                                            },
                                            on: {
                                              click: function($event) {
                                                $event.stopPropagation()
                                                return _vm.getRate.apply(
                                                  null,
                                                  arguments
                                                )
                                              }
                                            }
                                          },
                                          [_vm._v(_vm._s(_vm.$t("getRate")))]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-flex",
                                      { attrs: { md9: "" } },
                                      [
                                        _c(
                                          "v-layout",
                                          [
                                            _vm.isLoadingRates
                                              ? _c(
                                                  "v-flex",
                                                  { attrs: { md2: "" } },
                                                  [
                                                    _c("v-progress-circular", {
                                                      attrs: {
                                                        indeterminate: "",
                                                        color: "primary"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              : _c(
                                                  "v-flex",
                                                  { attrs: { md10: "" } },
                                                  [
                                                    _c(
                                                      "v-layout",
                                                      {
                                                        attrs: {
                                                          row: "",
                                                          "no-wrap": "",
                                                          "text-xs-center": ""
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                        " +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "baseCharge"
                                                              )
                                                            ) +
                                                            ": $ " +
                                                            _vm._s(
                                                              _vm.displayRate
                                                                .rate || "----"
                                                            ) +
                                                            "\n                        "
                                                        ),
                                                        _vm.displayRate
                                                          .surcharge
                                                          ? _c("span", [
                                                              _vm._v(
                                                                "\n                          \n                          " +
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "surcharge"
                                                                    )
                                                                  ) +
                                                                  ": $ " +
                                                                  _vm._s(
                                                                    _vm
                                                                      .displayRate
                                                                      .surcharge ===
                                                                      null
                                                                      ? "----"
                                                                      : _vm
                                                                          .displayRate
                                                                          .surcharge
                                                                  ) +
                                                                  "\n                        "
                                                              )
                                                            ])
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        _vm.displayRate
                                                          .hasResidentialCheck
                                                          ? _c(
                                                              "small",
                                                              {
                                                                staticStyle: {
                                                                  color: "blue"
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      _vm
                                                                        .displayRate
                                                                        .isResidential
                                                                        ? "residential"
                                                                        : "commercial"
                                                                    )
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        _vm.displayRate
                                                          .surcharge
                                                          ? _c("span", [
                                                              _vm._v(
                                                                "\n                            \n                          " +
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "total"
                                                                    )
                                                                  ) +
                                                                  ": $ " +
                                                                  _vm._s(
                                                                    _vm
                                                                      .displayRate
                                                                      .rate
                                                                      ? _vm.toMoney(
                                                                          _vm
                                                                            .displayRate
                                                                            .rate +
                                                                            _vm
                                                                              .displayRate
                                                                              .surcharge
                                                                        )
                                                                      : "----"
                                                                  ) +
                                                                  "\n                        "
                                                              )
                                                            ])
                                                          : _vm._e(),
                                                        _vm._v(
                                                          "\n                           \n                        "
                                                        ),
                                                        _vm.displayRate
                                                          .estimatedDelivery &&
                                                        _vm.displayRate
                                                          .estimatedDelivery !==
                                                          "N/A" &&
                                                        ![
                                                          "xs",
                                                          "sm",
                                                          "md"
                                                        ].includes(
                                                          _vm.$vuetify
                                                            .breakpoint.name
                                                        )
                                                          ? _c("span", [
                                                              _vm._v(
                                                                "\n                          " +
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "estDelivery"
                                                                    )
                                                                  ) +
                                                                  ": " +
                                                                  _vm._s(
                                                                    _vm.formatEstDeliveryDate(
                                                                      _vm
                                                                        .displayRate
                                                                        .estimatedDelivery
                                                                    )
                                                                  ) +
                                                                  "\n                        "
                                                              )
                                                            ])
                                                          : _vm._e()
                                                      ]
                                                    )
                                                  ],
                                                  1
                                                )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _vm.rates.length > 1 && !_vm.isLoadingRates
                                      ? _c(
                                          "v-flex",
                                          {
                                            staticClass:
                                              "subheading font-weight-bold",
                                            attrs: { md2: "" }
                                          },
                                          [
                                            _c(
                                              "v-menu",
                                              {
                                                attrs: {
                                                  "close-on-content-click": false,
                                                  "nudge-width": 200,
                                                  "offset-x": ""
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "activator",
                                                      fn: function(ref) {
                                                        var on = ref.on
                                                        return [
                                                          _c(
                                                            "v-btn",
                                                            _vm._g(
                                                              {
                                                                attrs: {
                                                                  dark: "",
                                                                  color:
                                                                    "primary",
                                                                  flat: ""
                                                                }
                                                              },
                                                              on
                                                            ),
                                                            [
                                                              _vm._v(
                                                                " More rates\n                      "
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      }
                                                    }
                                                  ],
                                                  null,
                                                  false,
                                                  2932867967
                                                ),
                                                model: {
                                                  value: _vm.moreRatesToggle,
                                                  callback: function($$v) {
                                                    _vm.moreRatesToggle = $$v
                                                  },
                                                  expression: "moreRatesToggle"
                                                }
                                              },
                                              [
                                                _vm._v(" "),
                                                _c(
                                                  "v-card",
                                                  [
                                                    _c("v-card-text", [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticStyle: {
                                                            height: "500px",
                                                            overflow: "auto"
                                                          }
                                                        },
                                                        [
                                                          _c("v-data-table", {
                                                            attrs: {
                                                              headers: [
                                                                {
                                                                  text: _vm.$t(
                                                                    "service"
                                                                  ),
                                                                  align: "left",
                                                                  sortable: false,
                                                                  value:
                                                                    "serviceType"
                                                                },
                                                                {
                                                                  text:
                                                                    _vm.$t(
                                                                      "baseCharge"
                                                                    ) + " ($)",
                                                                  align: "left",
                                                                  sortable: false,
                                                                  value: "rate"
                                                                },
                                                                {
                                                                  text:
                                                                    _vm.$t(
                                                                      "surcharge"
                                                                    ) + " ($)",
                                                                  align: "left",
                                                                  sortable: false,
                                                                  value:
                                                                    "surcharge"
                                                                },
                                                                {
                                                                  text:
                                                                    _vm.$t(
                                                                      "total"
                                                                    ) + " ($)",
                                                                  align: "left",
                                                                  sortable: false,
                                                                  value: "total"
                                                                },
                                                                {
                                                                  text: _vm.$t(
                                                                    "estDelivery"
                                                                  ),
                                                                  align: "left",
                                                                  sortable: false,
                                                                  value: ""
                                                                }
                                                              ],
                                                              items: _vm.rates,
                                                              "item-key":
                                                                "serviceType",
                                                              "hide-actions": ""
                                                            },
                                                            scopedSlots: _vm._u(
                                                              [
                                                                {
                                                                  key: "items",
                                                                  fn: function(
                                                                    ref
                                                                  ) {
                                                                    var item =
                                                                      ref.item
                                                                    return [
                                                                      _c("td", [
                                                                        _c(
                                                                          "a",
                                                                          {
                                                                            attrs: {
                                                                              linkify:
                                                                                ""
                                                                            },
                                                                            on: {
                                                                              click: function(
                                                                                $event
                                                                              ) {
                                                                                return _vm.switchShippingService(
                                                                                  item
                                                                                )
                                                                              }
                                                                            }
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                item.serviceDescription ||
                                                                                  item.serviceType
                                                                              )
                                                                            )
                                                                          ]
                                                                        )
                                                                      ]),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      item.message
                                                                        ? [
                                                                            _c(
                                                                              "td",
                                                                              {
                                                                                attrs: {
                                                                                  colspan:
                                                                                    "4"
                                                                                }
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  _vm._s(
                                                                                    item.message
                                                                                  )
                                                                                )
                                                                              ]
                                                                            )
                                                                          ]
                                                                        : [
                                                                            _c(
                                                                              "td",
                                                                              [
                                                                                _vm._v(
                                                                                  _vm._s(
                                                                                    item.rate
                                                                                  )
                                                                                )
                                                                              ]
                                                                            ),
                                                                            _vm._v(
                                                                              " "
                                                                            ),
                                                                            _c(
                                                                              "td",
                                                                              [
                                                                                _vm._v(
                                                                                  _vm._s(
                                                                                    item.surcharge ||
                                                                                      "N/A"
                                                                                  )
                                                                                )
                                                                              ]
                                                                            ),
                                                                            _vm._v(
                                                                              " "
                                                                            ),
                                                                            _c(
                                                                              "td",
                                                                              [
                                                                                _vm._v(
                                                                                  _vm._s(
                                                                                    item.total
                                                                                  )
                                                                                )
                                                                              ]
                                                                            ),
                                                                            _vm._v(
                                                                              " "
                                                                            ),
                                                                            _c(
                                                                              "td",
                                                                              [
                                                                                _vm._v(
                                                                                  "\n                                  " +
                                                                                    _vm._s(
                                                                                      _vm.formatEstDeliveryDate(
                                                                                        item.estimatedDelivery
                                                                                      )
                                                                                    ) +
                                                                                    "\n                                "
                                                                                )
                                                                              ]
                                                                            )
                                                                          ]
                                                                    ]
                                                                  }
                                                                }
                                                              ],
                                                              null,
                                                              false,
                                                              1949266989
                                                            )
                                                          })
                                                        ],
                                                        1
                                                      )
                                                    ]),
                                                    _vm._v(" "),
                                                    _c(
                                                      "v-card-actions",
                                                      [
                                                        _c("v-spacer"),
                                                        _vm._v(" "),
                                                        _c(
                                                          "v-btn",
                                                          {
                                                            attrs: {
                                                              color: "primary",
                                                              flat: ""
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                _vm.moreRatesToggle = false
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t("close")
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.errorMessage
                          ? _c(
                              "v-layout",
                              [
                                _c(
                                  "v-flex",
                                  {
                                    staticClass:
                                      "red--text font-weight-bold text-xs-right"
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(_vm.errorMessage) +
                                        "\n            "
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        Object.keys(_vm.warningMessages).length
                          ? _c("v-layout", { attrs: { "justify-end": "" } }, [
                              _c(
                                "span",
                                {
                                  staticClass: "font-weight-bold text-xs-right",
                                  staticStyle: { "background-color": "yellow" }
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        Object.values(_vm.warningMessages).join(
                                          ", "
                                        )
                                      ) +
                                      "\n            "
                                  )
                                ]
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.recommendAddress
                          ? _c(
                              "v-layout",
                              {
                                attrs: {
                                  "align-baseline": "",
                                  "justify-end": ""
                                }
                              },
                              [
                                _c(
                                  "v-flex",
                                  {
                                    staticStyle: { display: "flex" },
                                    attrs: { xs8: "" }
                                  },
                                  [
                                    _c("v-flex", {
                                      staticStyle: { flex: "1" }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "font-weight-bold",
                                        staticStyle: {
                                          padding: "0px 5px",
                                          display: "flex",
                                          "align-items": "center",
                                          "background-color": "yellow"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(_vm.$t("recommendAddress")) +
                                            ": " +
                                            _vm._s(_vm.recommendAddressFormat) +
                                            "\n              "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-flex",
                                      { attrs: { md2: "" } },
                                      [
                                        _c(
                                          "v-btn",
                                          {
                                            staticStyle: { margin: "0px 6px" },
                                            attrs: {
                                              color: "primary",
                                              flat: ""
                                            },
                                            on: {
                                              click: _vm.useRecommendAddress
                                            }
                                          },
                                          [_vm._v(_vm._s(_vm.$t("apply")))]
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ]
        },
        proxy: true
      }
    ]),
    model: {
      value: _vm.value,
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0d760fac", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d760fac","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LabelCreatePopup.vue
// module id = null
// module chunks = 